import { Directive, ElementRef, inject, OnDestroy, OnInit, Renderer2 } from '@angular/core'
import { MessagesService } from '../../../services/messages/messages.service'
import { Subject } from 'rxjs'
import { distinctUntilChanged, map, switchMap, takeUntil } from 'rxjs/operators'
import { ToggleableModulesService } from '../../config/toggleable-modules/toggleable-modules.service'
import { ToggleableModulesName } from '../../config/toggleable-modules/ToggleableModules'

@Directive({
  selector: '[appMenuNotificationDot]',
  standalone: true,
})
export class MenuNotificationDotDirective implements OnInit, OnDestroy {
  private elRef = inject(ElementRef)
  private renderer = inject(Renderer2)
  private msgService = inject(MessagesService)
  private toggleableModulesService = inject(ToggleableModulesService)

  unsubscribe = new Subject<void>()
  dot: HTMLDivElement
  countEl: HTMLDivElement

  private enabled = false
  private TAG = 'MenuNotificationDotDirective'

  ngOnInit() {
    this.toggleableModulesService
      .isActive(ToggleableModulesName.MESSAGING)
      .pipe(
        distinctUntilChanged(),
        map((active) => (this.enabled = active)),
        map((_) => this.createDot(this.elRef, this.renderer)),
        switchMap((_) => this.msgService.getCombinedUnreadMessagesCount()),
        takeUntil(this.unsubscribe),
      )
      .subscribe((count) => {
        console.log(`${this.TAG}#count got new count`, count, this.enabled)
        if (count) {
          this.renderUnreadCount(count)
          this.enabled ? this.showDot() : this.hideDot()
        } else {
          this.hideDot()
        }
      })
  }

  private createDot(elRef: ElementRef, r: Renderer2) {
    if (this.dot) return

    this.dot = r.createElement('div')
    this.dot.classList.add('menuNotificationDot')

    this.dot.style.backgroundColor = 'var(--ion-color-tertiary)'
    this.dot.style.height = '1em'
    this.dot.style.width = 'auto'
    this.dot.style.position = 'absolute'
    this.dot.style.top = '0.5em'
    this.dot.style.left = '1.6em'
    this.dot.style.borderRadius = '40%'
    this.dot.style.pointerEvents = 'none'
    this.dot.style.paddingLeft = '0.2em'
    this.dot.style.paddingRight = '0.2em'

    this.dot.style.display = 'none'

    this.countEl = r.createElement('div')
    this.countEl.classList.add('menuNotificationDot-count')
    this.countEl.style.fontSize = '0.8em'
    this.countEl.style.textAlign = 'center'
    this.countEl.style.color = 'white'

    r.appendChild(this.dot, this.countEl)

    this.renderer.appendChild(this.renderer.parentNode(elRef.nativeElement), this.dot)
  }

  ngOnDestroy(): void {
    this.unsubscribe.next()
    this.unsubscribe.complete()
  }

  private showDot() {
    this.dot.style.display = 'block'
  }

  private hideDot() {
    this.dot.style.display = 'none'
  }

  private renderUnreadCount(count: number) {
    this.countEl.innerText = String(count)
  }
}
